import React, { Children, useEffect } from 'react'
import { Animated, ScrollView, View } from 'react-native'
import { Container } from '../atoms'
import { Circle } from 'react-native-svg'
import { useResponsive } from '../../utils/hooks'
import { TouchableOpacity } from 'react-native-gesture-handler'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../store'

export const AnimatedCircle = Animated.createAnimatedComponent(Circle)

/**
 *
 * @param children
 * @param onEnd, Callback function
 * @returns {JSX.Element}
 * @constructor
 */
let scrollRef

interface Props {
  children: React.ReactNode
  style?: any
}
export const Carousel = observer(({ children, style }: Props) => {
  const { mobileWidth: width } = useResponsive()
  const [screen, setScreen] = React.useState(0)
  const childrenArray = Children.toArray(children)
  const { userStore } = useStore()

  useEffect(() => {
    if (!scrollRef) return
    setTimeout(() => {
      scrollRef?.scrollTo({ x: width * screen, animated: false }) //Without settimeout scrollTo doesnt work
    }, 1)
  }, [screen, width])

  const bullets: Array<any> = []
  for (let i = 0; i < childrenArray.length; i++) {
    bullets.push(
      <TouchableOpacity
        key={i}
        style={{
          margin: 5,
          height: 6,
          width: 6,
          borderRadius: 3,
          backgroundColor: screen === i ? '#99ADBA' : '#E6EBEE',
        }}
        onPress={() => {
          setScreen(i)
        }}
      />,
    )
  }

  return (
    <>
      <View style={style}>
        <ScrollView
          ref={(ref) => (scrollRef = ref)}
          horizontal
          contentContainerStyle={{
            width: `${width * childrenArray.length}%`,
          }}
          showsHorizontalScrollIndicator={false}
          scrollEventThrottle={200}
          //scrollEnabled
          // eslint-disable-next-line i18next/no-literal-string
          decelerationRate="fast"
          pagingEnabled
          onScroll={(event) => {
            setScreen(
              Math.round(event.nativeEvent.contentOffset.x / (width * 0.8)),
            )
          }}
        >
          {childrenArray.map((child, index) => {
            return (
              <Container
                key={index}
                style={{
                  flex: 1,
                  width:
                    index === childrenArray.length - 1
                      ? width * 0.9
                      : width * 0.8,
                }}
              >
                {child}
              </Container>
            )
          })}
        </ScrollView>
      </View>
      <View
        style={{
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          paddingTop: 8,
        }}
      >
        {bullets.length > 1 && bullets}
      </View>
    </>
  )
})
